import React from "react";

const CityIcon  = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M0 13.5V3H3V0H10.5V6H13.5V13.5H7.5V10.5H6V13.5H0ZM1.5 12H3V10.5H1.5V12ZM1.5 9H3V7.5H1.5V9ZM1.5 6H3V4.5H1.5V6ZM4.5 9H6V7.5H4.5V9ZM4.5 6H6V4.5H4.5V6ZM4.5 3H6V1.5H4.5V3ZM7.5 9H9V7.5H7.5V9ZM7.5 6H9V4.5H7.5V6ZM7.5 3H9V1.5H7.5V3ZM10.5 12H12V10.5H10.5V12ZM10.5 9H12V7.5H10.5V9Z" fill="#999999"/>
  </svg>
);

export default CityIcon ;

